import React from 'react'
import Media from 'react-media'

import Layout from '@cinch/oxd-layouts/regular/src'

import tokens from '@cinch/oxd-utils/tokens/src'

import * as styles from './our-commitment.module.css'
import IconContentBlock, { ContentBlock } from '@cinch/oxd-components/icon-content-block/icon-content-block.component'
import Wrapper from '@cinch/oxd-components/wrapper/src'
import Hero, { HeroImage } from '@cinch/oxd-components/hero/src'
import IconList from '@cinch/oxd-components/icon-list/src'
import { Oval } from '@cinch/oxd-components/icons/src'
import { Text } from '@cinch-labs/design-system'
import SecondaryWrapper from '@cinch/oxd-components/button/src/secondary-wrapper'

interface AboutUsPage {
  commitment: {
    commitmentTitle: string
    content: ContentBlock[]
  }
  heroImage: HeroImage
  i18n: Cinch.WebAppTranslations['ourCommitmentPage']
}

const CommitmentPage: React.FC<AboutUsPage> = ({ i18n, commitment, heroImage }) => {
  const body = i18n.heroBody.split('\n').map((x: any, i: number) => <p key={i}>{x}</p>)
  const hero = <Hero heading={i18n.heroTitle} content={body} heroImage={heroImage} />

  const commitmentBullets = commitment.content.map((content) => (
    <IconContentBlock
      key={content.title}
      {...content}
      ctaTag={{
        event: 'click',
        eventCategory: 'commitment',
        eventLabel: content.ctaText || '',
        eventAction: 'navigation',
      }}
    />
  ))
  const chooseToBuyOnlineBullets = i18n.chooseToBuyOnlineBullets.map((bullet, i) => (
    <Text className={styles.iconList} key={i} element="p" fontWeight="medium" fontSize="s" lineHeight="body">
      {bullet}
    </Text>
  ))

  return (
    <Media defaultMatches={true} query={tokens.customMedia.m}>
      {(matches) => (
        <Layout hero={hero} isFluid={true} hasBlendedFooter={true}>
          <Wrapper>
            <div className={styles.container}>
              <Text className={styles.title} element="h3" fontWeight="bold" fontSize="xl" lineHeight="display">
                {commitment.commitmentTitle}
              </Text>

              <div>{commitmentBullets}</div>
            </div>
          </Wrapper>

          <section className={styles.contentContainer}>
            <Wrapper>
              <div className={styles.container}>
                <Text className={styles.title} element="h3" fontWeight="bold" fontSize="xl" lineHeight="display">
                  {i18n.chooseToBuyOnlineTitle}
                </Text>

                <IconList
                  className={styles.body}
                  bulletIcon={Oval}
                  bulletText={(chooseToBuyOnlineBullets as unknown) as string[]}
                  hasGradient={true}
                  gradientId={'bravo'}
                />

                <SecondaryWrapper
                  classNames={{ button: styles.buttonOverride }}
                  isFullWidth={!matches}
                  tag={{
                    event: 'click',
                    eventCategory: 'commitment',
                    eventLabel: i18n.chooseToBuyOnlineCtaText,
                    eventAction: 'navigation',
                  }}
                  element="a"
                  href="/find-vehicle"
                >
                  {i18n.chooseToBuyOnlineCtaText}
                </SecondaryWrapper>
              </div>

              <div className={styles.contentRightContainer}>
                <div className={styles.container}>
                  <Text className={styles.title} element="h3" fontWeight="bold" fontSize="xl" lineHeight="display">
                    {i18n.needHelpChoosingTitle}
                  </Text>

                  <Text className={styles.body} element="p" fontWeight="book" fontSize="s" lineHeight="body">
                    {i18n.needHelpChoosingBody}
                  </Text>

                  <SecondaryWrapper
                    classNames={{ button: styles.buttonOverride }}
                    isFullWidth={!matches}
                    tag={{
                      event: 'click',
                      eventCategory: 'commitment',
                      eventLabel: i18n.needHelpChoosingCtaText,
                      eventAction: 'navigation',
                    }}
                    element="a"
                    href="/lifestyle"
                  >
                    {i18n.needHelpChoosingCtaText}
                  </SecondaryWrapper>
                </div>

                <div className={styles.container}>
                  <Text className={styles.title} element="h3" fontWeight="bold" fontSize="xl" lineHeight="display">
                    {i18n.dealershipsYouCanTrustTitle}
                  </Text>

                  <Text className={styles.body} element="p" fontWeight="book" fontSize="s" lineHeight="body">
                    {i18n.dealershipsYouCanTrustBody}
                  </Text>

                  <SecondaryWrapper
                    classNames={{ button: styles.buttonOverride }}
                    isFullWidth={!matches}
                    tag={{
                      event: 'click',
                      eventCategory: 'commitment',
                      eventLabel: i18n.dealershipsYouCanTrustCtaText,
                      eventAction: 'navigation',
                    }}
                    element="a"
                    href="/dealers/find-vehicle"
                  >
                    {i18n.dealershipsYouCanTrustCtaText}
                  </SecondaryWrapper>
                </div>
              </div>
            </Wrapper>
          </section>
        </Layout>
      )}
    </Media>
  )
}

export default CommitmentPage
